<template>
  <div class="container-full">
    <img src="/img/avatars/lpnew.png" class="image-lion-print" />
    <div class="div-sub-print">
      <h2>APLIKASI PENGAJUAN PERWAKILAN P.O.S. LION PARCEL</h2>
    </div>
    <table class="table-custome">
      <col />
      <col />
      <colgroup span="3"></colgroup>
      <thead>
        <tr>
          <th colspan="3" scope="colgroup" class="th-custome">
            <h3>BENTUK PENGAJUAN</h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="tr-custome">
          <td class="td-custome">Id Registrasi : {{ agentData.agent_id }}</td>
          <td class="td-custome">
            Bentuk Pengajuan : {{ agentData.registration_type }}
          </td>
        </tr>
        <tr>
          <td class="td-custome">Status Pengajuan : {{ agentData.flag }}</td>
          <td class="td-custome">
            Tanggal Pengajuan : {{ agentData.created_at }}
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table-custome">
      <col />
      <col />
      <colgroup span="3"></colgroup>
      <thead>
        <tr>
          <th colspan="3" scope="colgroup" class="th-custome">
            <h3>DATA PENDAFTAR</h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Nama Lengkap : {{ agentData.register_name }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Alamat : {{ agentData.register_address }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Email : {{ agentData.register_email }}
          </td>
        </tr>
        <tr>
          <td class="td-custome">No HP : {{ agentData.phone_number }}</td>
          <td class="td-custome">No HP2 : {{ agentData.phone_number_two }}</td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Darimana Anda mendapatkan informasi tentang pendaftaran ini :
            {{ agentData.resource }}
          </td>
        </tr>
      </tbody>
    </table>

    <table
      class="table-custome"
      v-if="agentData.registration_type === 'Badan Usaha'"
    >
      <col />
      <col />
      <colgroup span="3"></colgroup>
      <thead>
        <tr>
          <th colspan="3" scope="colgroup" class="th-custome">
            <h3>DATA PERUSAHAAN</h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="tr-custome">
          <td class="td-custome">
            Bidang Perusahaan : {{ agentData.company_type }}
          </td>
        </tr>
        <tr>
          <td class="td-custome">
            Nama Perusahaan : {{ agentData.company_name }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td class="td-custome">
            Nama Pimpinan : {{ agentData.company_chairman_name }}
          </td>
        </tr>
        <tr>
          <td class="td-custome">
            Alamat Perusahaan : {{ agentData.company_address }}
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table-custome">
      <col />
      <col />
      <colgroup span="3"></colgroup>
      <thead>
        <tr>
          <th colspan="3" scope="colgroup" class="th-custome">
            <h3>DATA LOKASI</h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Lokasi : {{ agentData.building_location }}
          </td>
        </tr>
        <tr>
          <td class="td-custome">
            Jenis Bangunan : {{ agentData.building_type }}
          </td>
          <td class="td-custome">
            Status Bangunan : {{ agentData.building_status }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Alamat Lokasi : {{ agentData.address_location }}
          </td>
        </tr>
        <tr>
          <td class="td-custome">Provinsi : {{ agentData.province }}</td>
          <td class="td-custome">Kota : {{ agentData.district }}</td>
        </tr>

        <tr>
          <td class="td-custome">Kecamatan : {{ agentData.sub_district }}</td>
          <td class="td-custome">Kelurahan : {{ agentData.village }}</td>
        </tr>
      </tbody>
    </table>
    <table class="table-custome">
      <col />
      <col />
      <colgroup span="3"></colgroup>
      <thead>
        <tr>
          <th colspan="3" scope="colgroup" class="th-custome">
            <h3>DATA TAMBAHAN</h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Apakah bersedia pickup ke customer? : {{ isPickup }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Apakah ada pengalaman di bidang pengiriman/logistik? :
            {{ isLogistic }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Apakah ada kenalan online shop di wilayah anda? : {{ isOlshop }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Geolocation : {{ agentData.latlong }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Apakah bersedia melakukan drop off paket ke shuttle / konsolidator
            terdekat? : {{ isDropOff }}
          </td>
        </tr>
        <tr class="tr-custome">
          <td colspan="3" scope="colgroup" class="td-custome">
            Apakah bersedia melakukan Top Up pertama senilai Rp. 5.000.000? :
            {{ isTopUp }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import moment from "moment";
import jwt from "jsonwebtoken";

export default {
  name: "PrintDataAgent",
  data() {
    return {
      agentData: {},
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      isPickup: "NO",
      isLogistic: "NO",
      isOlshop: "NO",
      isDropOff: "NO",
      isTopUp: "NO",
    };
  },
  beforeMount() {
    this.authentication();
    this.getDataByID();
  },
  updated() {
    window.print();
  },
  methods: {
    getDataByID() {
      let agentID = this.$route.params.id;
      axios
        .get(`${this.domain}/v2/agent/${agentID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.agentData = response.data;
          moment.locale("ID");
          this.agentData.created_at = moment(
            String(this.agentData.created_at)
          ).format("LL");
          if (this.agentData.is_pickup === true) {
            this.isPickup = "YES";
          }
          if (this.agentData.is_logistic === true) {
            this.isLogistic = "YES";
          }
          if (this.agentData.is_olshop === true) {
            this.isOlshop = "YES";
          }
          if (this.agentData.is_drop_off === true) {
            this.isDropOff = "YES";
          }
          if (this.agentData.is_top_up === true) {
            this.isTopUp = "YES";
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
  },
};
</script>

<style scoped>
@import "./Agent.css";
</style>
